wbApp.controller('UsersDetailCtrl', ['$scope', 'userSvc', 'securitySvc', 'tenantSettingSvc', '$http', 'messageBoxSvc',
function ($scope, userSvc, securitySvc, tenantSettingSvc, $http, messageBoxSvc) {

    $scope.userUpdateRole = securitySvc.isInRole('User.Update');
    
    $scope.tenantSetting = tenantSettingSvc.settings;
    let hasSecondContact =
        ($scope.tenantSetting.mandatoryEmail2 < 3) ||
        ($scope.tenantSetting.mandatoryPhone2 < 3) ||
        ($scope.tenantSetting.mandatoryUserNationality2 < 3) ||
        ($scope.tenantSetting.mandatoryUserName2 < 3) ||
        ($scope.tenantSetting.mandatoryUserSurname2 < 3) ||
        ($scope.tenantSetting.mandatoryUserMiddleName2 < 3) ||
        ($scope.tenantSetting.mandatoryUserAddress2 < 3) ||
        ($scope.tenantSetting.mandatoryUserIdentityCardNumber2 < 3) ||
        ($scope.tenantSetting.mandatoryUserPersonalIDNumber2 < 3) ||
        ($scope.tenantSetting.mandatoryUserBirthday2 < 3);
            
    $scope.IDMInfoLockedForEdit = $scope.userDetail.idmEmailConfirmed && $scope.userDetail.boundToIDM;
    $scope.userDetailOrig = angular.copy($scope.userDetail);
    $scope.isSaving = false;
    
    $scope.onIDMLockClick = function() {
        if ($scope.IDMInfoLockedForEdit) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_TITLE_INFORMATION',
                message: 'TXT_ENABLE_IDM_EDIT',
                buttons: [{
                    text: 'TXT_BTN_CANCEL'
                }, {
                    text: 'TXT_BTN_OK',
                    callback: function () {
                        $scope.IDMInfoLockedForEdit = !$scope.IDMInfoLockedForEdit;
                    }
                }]
            });
        } else {
            $scope.IDMInfoLockedForEdit = !$scope.IDMInfoLockedForEdit;
        }
    }

    $scope.onUserDetailSave = function (data) {
        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        if (data.isNew) {
            userSvc.insert(data, success, error);
        } else {
            data.overrideIDMProperties = !$scope.IDMInfoLockedForEdit; // && securitySvc.isInRole('User.Update');
            userSvc.update(data, success, error);
            //data.overrideIDMProperties = false;
        }

        function success(newUser) {
            $scope.isSaving = false;
            if (!!$scope.userSaved) {
                $scope.userSaved(newUser);
            }
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.isSaving = false;
            $scope.userDetailError = errorResult;
        }
    }

    $scope.onUserDetailSaveWithIDMRequest = function (data) {
        data.requestBindToIDM = true;
        $scope.onUserDetailSave(data);
    }

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.userDetailOrig) && !$scope.preFilled;
    }


    $scope.typeAheadAddress = [];

    $scope.allMatch = function () {
        return true;
    };

    $scope.getAddress = function (viewValue) {
        if (viewValue) {
            let params = {
                address: viewValue,
                language: 'cs',
                region: 'cz',
                bounds: '48.270777,12.172380|51.246709,19.922157', // Czech republic bounds
                key: 'AIzaSyDdpRFWJaEcASaUgQxTdi8i42aaCaKfS0A'
            };
            return $http.get('https://maps.googleapis.com/maps/api/geocode/json', { params: params })
                .then(function (res) {
                    $scope.typeAheadAddress.length = 0;
                    $scope.typeAheadAddress.push.apply($scope.typeAheadAddress, res.data.results);
                });
        }
    };

    $scope.detailTabs = [
    {
        title: 'TXT_USER_ACCOUNT',
        template: "users/users-detail-main-tab.html"
    },
    {
        title: "TXT_LBL_CONTACT_DETAILS",
        template: "users/users-detail-contact-tab.html"
    }];
    
    if (hasSecondContact) {
        $scope.detailTabs.push({
            title: "TXT_LBL_SECONDARY_CONTACT",
            template: "users/users-detail-second-contact-tab.html"
        })
    }
    
    $scope.detailTabs.push({
        title: "TXT_LBL_ADITIONAL",
        template: "users/users-detail-aditional-tab.html"
    });

    $scope.detailTabs.activeTab = 0;

}]);
